<div class="dropdown">

  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">Notificaciones</div>
      <div class="dropdown-subheading">
        {{ notifications.length > 0 ? 'Tienes ' + notifications.length + ' notificaciones.' : '¡Todo al día!' }}
      </div>
    </div>
  </div>

  <div class="dropdown-content">
    <!-- Spinner de carga -->
    <div *ngIf="isLoading" class="loading-indicator">
      <div class="loading-spinner"></div>
      <span>Cargando notificaciones...</span>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoading && notifications.length === 0" class="empty-state">
      <mat-icon svgIcon="mat:notifications_none" class="empty-state-icon"></mat-icon>
      <p class="empty-state-text">No tienes notificaciones pendientes</p>
    </div>

    <!-- Notificaciones -->
    <a *ngFor="let notification of notifications; trackBy: trackById"
       [class.read]="notification.leida"
       class="notification flex items-center"
       (click)="markAsRead(notification.id)"
       matRipple>
      <mat-icon [ngClass]="notification.colorClass"
                [svgIcon]="notification.icon"
                class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto">
        <div class="notification-label">{{ notification.descripcion }}</div>
        <div class="notification-description">
          {{ notification.fecha_creacion | fechaEspanol:'relativa' }}
        </div>
      </div>
    </a>
  </div>

  <div *ngIf="notifications.length > 0" class="dropdown-footer flex items-center justify-center">
    <button mat-button (click)="markAllAsRead()"
      class="!text-mostasa hover:!text-mostasa/80 font-medium">
      Marcar todas como leídas
    </button>
  </div>
</div>
